import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { InformationCircle } from '../../../../assets/svgs/icons';
import styles from './styles.module.css';

const NOTICE_CONTENT_TEMPLATE = {
  partial: {
    accentClass: styles.partial,
    badgeKey: 'chatsocket.insufficient_balance.badge_insufficient',
    titleKey: 'chatsocket.insufficient_balance.batch_title_partial',
    messageKey: 'chatsocket.insufficient_balance.batch_message_partial',
  },
  zero: {
    accentClass: styles.zero,
    badgeKey: 'chatsocket.insufficient_balance.badge_zero',
    titleKey: 'chatsocket.insufficient_balance.batch_title_zero',
    messageKey: 'chatsocket.insufficient_balance.batch_message_zero',
  },
};

export const BatchEditLimitNoticeModal = ({
  isOpen,
  variant = 'partial',
  onClose,
}) => {
  const { t } = useTranslation();
  const template = NOTICE_CONTENT_TEMPLATE[variant] || NOTICE_CONTENT_TEMPLATE.partial;
  const content = {
    accentClass: template.accentClass,
    badge: t(template.badgeKey),
    title: t(template.titleKey),
    message: t(template.messageKey),
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
        >
          <motion.div
            className={`${styles.modal} ${content.accentClass}`}
            initial={{ opacity: 0, scale: 0.96, y: 18 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.96, y: 18 }}
            transition={{ duration: 0.18 }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="batch-edit-limit-notice-title"
            onClick={(event) => event.stopPropagation()}
          >
            <div className={styles.header}>
              <span className={styles.badge}>
                <InformationCircle color={variant === 'zero' ? '#B91C1C' : '#9002CD'} />
                {content.badge}
              </span>
              <h2 id="batch-edit-limit-notice-title" className={styles.title}>
                {content.title}
              </h2>
              <p className={styles.message}>{content.message}</p>
            </div>

            <div className={styles.actions}>
              <button
                type="button"
                className={styles.closeButton}
                onClick={onClose}
              >
                {t('chatsocket.buttons.understand')}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BatchEditLimitNoticeModal;
